module.exports = "/_next/static/images/Hero-05a0d2f5b97290e434fa1c2b535056b9.webp";